/**
 * Ventana encuesta satisfacción alumnos (vie–dom). Misma lógica que ambiente / api-movil.
 */
import {
  buildVentanaEncuestaAmbiente,
  enVentanaAmbiente,
  idCicloSugeridoEncuestaAmbiente,
  hoyYmdAmbiente,
  ORDEN_CALENDARIO_EXCEL,
  VENTANAS_EXCEL_CICLOS,
  claveCicloDesdeNombre,
} from './encuesta-ambiente-ventana.js'

export const buildVentanaEncuestaSatisfaccion = buildVentanaEncuestaAmbiente
export const enVentanaSatisfaccion = enVentanaAmbiente
export const idCicloSugeridoEncuestaSatisfaccion = idCicloSugeridoEncuestaAmbiente
export const hoyYmdSatisfaccion = hoyYmdAmbiente
export { ORDEN_CALENDARIO_EXCEL, VENTANAS_EXCEL_CICLOS, claveCicloDesdeNombre }
